import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import styles from './Footer.module.css';

function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>


          <div className={styles.footerSection}>
            <h3>{t('footer.navigation')}</h3>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/">{t('footer.home')}</Link>
              </li>
              <li>
                <Link to="/search">{t('footer.hairstylists')}</Link>
              </li>
              <li>
                <Link to="/posts">{t('footer.posts')}</Link>
              </li>
            </ul>
          </div>

          <div className={styles.footerSection}>
            <h3>{t('footer.information')}</h3>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/about">{t('footer.about')}</Link>
              </li>
              <li>
                <Link to="/faq">{t('footer.faq')}</Link>
              </li>
              <li>
                <a href="mailto:cheriecoiffer@gmail.com">{t('footer.contact')}</a>
              </li>
              <li>
                <a href="/mentions-legales">{t('footer.legal')}</a>
              </li>
            </ul>
          </div>

          <div className={styles.footerSection}>
            <h3>{t('footer.followUs')}</h3>
            <div className={styles.socialLinks}>
              <a href="https://instagram.com/cheriecoiffer" target="_blank" rel="noopener noreferrer" aria-label={t('footer.instagram')}>{t('footer.instagram')}</a>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>&copy; {new Date().getFullYear()} Chérie Coiffer. {t('footer.allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

